import * as React from 'react';
import { SVGProps } from 'react';

const IconFileVideoSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 2h16v20H4V2Zm1 1v2.5h2V3H5Zm3 0v8.5h8V3H8Zm9 0v2.5h2V3h-2Zm2 3.5h-2v2h2v-2Zm0 3h-2v2h2v-2Zm0 3h-2v2h2v-2Zm0 3h-2v2h2v-2Zm0 3h-2V21h2v-2.5ZM16 21v-8.5H8V21h8Zm-9 0v-2.5H5V21h2Zm-2-3.5h2v-2H5v2Zm0-3h2v-2H5v2Zm0-3h2v-2H5v2Zm0-3h2v-2H5v2Z"
    />
  </svg>
);
export default IconFileVideoSizeM;
